import { api } from ".";
import type { IAlert } from "@/models";

export const AlertService = {
  GetAlerts: (accountId: number) => {
    return api.get<IAlert[]>(`int/alerts/${accountId}`);
  },
};
